<template>
  <b-container fluid>
    <b-row style="background-color: #eaeaea; height: calc(-56px + 100vh);">
      <b-col>
        <b-button
            size="sm"
            variant="outline-secondary"
            @click="sidebarVisible = !sidebarVisible"
            pill
            style="position: absolute; top: 1rem;"
        >
          {{ selectedDashboard }}
        </b-button>
        <b-sidebar
            v-model="sidebarVisible"
            class="pbi-sidebar"
            id="sidebar-dashboard-menu"
            title="Dashboard"
            bg-variant="dark"
            text-variant="light"
            shadow
        >
          <div class="px-3 py-2">
            <sidemenu v-model="selectedDashboard" :menu="menuItems"/>
          </div>
        </b-sidebar>
        <router-view/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*global _*/

import sidemenu from '@/components/dashboard/Sidemenu';
import application from '@/mixins/application';

export default {
  name: 'Dashboard',
  components: {
    sidemenu
  },
  mixins: [application],
  mounted() {
    const vm = this;

    vm.axios.get('/api/dashboard/dashboards').then(function (resp) {
      if (resp.data) {
        vm.list = resp.data;
      }
    });
  },
  data() {
    return {
      list: [{dashboardId: 1, title: 'Analytic Dashboard', href: null, parentId: -1},],
      selectedDashboard: 'Menu',
      sidebarVisible: true
    };
  },
  watch: {
    $route(to) {
      if (to.path === '/dashboard/main') {
        this.sidebarVisible = true;
      }
      this.selectedDashboard = 'Menu';
    }
  },
  computed: {
    menuItems: function () {
      try {
        const list = _.sortBy(this.list, ['parentId']);
        const root = _.find(list, {parentId: -1});
        const menu = this.GetNestedList(root, list);
        const user = this.$store.state.user;
        const neededBrands = ['F1', 'T1', 'R1', 'P1', 'J1'];
        const neededBrandsNotPermitted = _.filter(neededBrands, function (v) {
          return _.some(user.brandPermission, v)
        });
        const isAllBrand = neededBrandsNotPermitted.length === 0;

        let checkBrandPermission = function (o) {
          for (let i in o) {
            if (Object.prototype.hasOwnProperty.call(o, i)) {
              if (o[i] !== null && o[i].isAllBrand && !isAllBrand) {
                o[i].hidden = true;
              }
              if (o[i] !== null && typeof o[i] == 'object') {
                checkBrandPermission(o[i]);
              }
            }
          }
        };
        checkBrandPermission(menu);

        return menu[0].child;
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.log(ex);
        return [];
      }
    }
  },
  methods: {
    GetNestedList(root, adjacencyList) {
      const added = {};
      const rootNode = _.cloneDeep(root);
      const SetDepth = function (currentNode) {
        added[currentNode.dashboardId] = true;
        while (_.some(adjacencyList, function (node) {
          return node.parentId === currentNode.dashboardId && !added[node.dashboardId];
        })) {
          let childNode = _.find(adjacencyList, function (node) {
            return node.parentId === currentNode.dashboardId && !added[node.dashboardId];
          });
          if (!Object.prototype.hasOwnProperty.call(currentNode, 'child')) {
            currentNode.child = [];
          }
          if (!_.some(currentNode.child, {dashboardId: childNode.dashboardId})) {
            currentNode.child.push(childNode);
          }
          added[childNode.dashboardId] = true;
          SetDepth(childNode, adjacencyList);
        }
      };
      SetDepth(rootNode);
      const menu = [];
      menu.push(rootNode);
      this.listTest = menu;
      return menu;
    }
  }
};
</script>

<style lang="scss">
.pbi-sidebar .b-sidebar {
  height: calc(-56px + 100vh);
  bottom: 0px;
  top: auto;
}
</style>
